<template>
    <article
        class="relative flex gap-4 rounded-2xl border border-gray-200 bg-white p-4 transition-colors hover:border-gray-300 sm:p-5 dark:border-default dark:bg-surface-card dark:hover:border-default"
    >
        <div class="flex w-10 shrink-0 flex-col items-center pt-0.5 text-gray-500 dark:text-txt-caption">
            <Icon name="heroicons:arrow-up" class="size-5" aria-hidden="true" />
            <span class="text-sm font-semibold text-gray-900 dark:text-txt-headings">{{ discussion.upvotes }}</span>
            <span class="sr-only">hlasov</span>
        </div>
        <div class="min-w-0 flex-1">
            <h3 class="text-lg font-semibold leading-snug text-gray-900 dark:text-txt-headings">
                <!-- The ::after stretches the link over the whole card. -->
                <NuxtLink
                    :to="discussionPath(discussion)"
                    class="after:absolute after:inset-0 after:rounded-2xl hover:text-primary-700 focus-visible:outline-none focus-visible:after:outline focus-visible:after:outline-2 focus-visible:after:outline-primary-600 dark:hover:text-primary-300"
                >
                    {{ discussion.title }}
                </NuxtLink>
            </h3>
            <p v-if="discussion.excerpt" class="mt-1 line-clamp-2 text-sm text-gray-600 dark:text-txt-body">
                {{ discussion.excerpt }}
            </p>
            <p class="mt-3 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-gray-500 dark:text-txt-caption">
                <span
                    v-if="showTopic && topic"
                    class="inline-flex items-center gap-1 font-medium text-[var(--topic-color)] dark:text-[var(--topic-color-dark)]"
                    :style="{ '--topic-color': topic.color, '--topic-color-dark': topic.darkColor }"
                >
                    <CIcon :name="topic.icon" :size="14" />
                    {{ topic.label }}
                </span>
                <span>{{ discussion.author.name }}</span>
                <time :datetime="discussion.createdAt">{{ discussionRelativeTime(discussion.createdAt) }}</time>
                <span class="inline-flex items-center gap-1">
                    <Icon name="heroicons:chat-bubble-left-right" class="size-4" aria-hidden="true" />
                    {{ discussionCommentLabel(discussion.commentCount) }}
                </span>
            </p>
        </div>
    </article>
</template>

<script setup lang="ts">
import type { DiscussionSummary } from '#shared/types/Discussion'
import { discussionCommentLabel, discussionRelativeTime, getDiscussionTopic } from '#shared/utils/discussions'
import { discussionPath } from '@/composables/discussions/useDiscussions'

const props = defineProps<{ discussion: DiscussionSummary; showTopic?: boolean }>()

const topic = computed(() => getDiscussionTopic(props.discussion.topic))
</script>
